module.exports = __webpack_public_path__ + "static/equativ-white-b6567918cb7c402283d997d45c77ad77.svg";